import { isValid, validateContent } from "./validate";

describe("isValid", () => {
    it("invalid onload attr", () => {
        const el = {
            nodeType: 1,
            nodeName: "svg",
            attributes: [{ name: "onload" }],
            childNodes: []
            // eslint-disable-next-line
        } as any;
        expect(isValid(el)).toBe(false);
    });

    it("invalid onclick attr", () => {
        const el = {
            nodeType: 1,
            nodeName: "svg",
            attributes: [{ name: "OnClIcK" }],
            childNodes: []
            // eslint-disable-next-line
        } as any;
        expect(isValid(el)).toBe(false);
    });

    it("invalid child SCRIPT elm", () => {
        const el = {
            nodeType: 1,
            nodeName: "svg",
            attributes: [],
            childNodes: [
                {
                    nodeType: 1,
                    nodeName: "SCRIPT",
                    attributes: [],
                    childNodes: []
                }
            ]
            // eslint-disable-next-line
        } as any;
        expect(isValid(el)).toBe(false);
    });

    it("invalid script elm", () => {
        const el = {
            nodeType: 1,
            nodeName: "script",
            attributes: [],
            childNodes: []
            // eslint-disable-next-line
        } as any;
        expect(isValid(el)).toBe(false);
    });

    it("is valid circle elm", () => {
        const el = {
            nodeType: 1,
            nodeName: "circle",
            attributes: [],
            childNodes: []
            // eslint-disable-next-line
        } as any;
        expect(isValid(el)).toBe(true);
    });

    it("is valid SVG elm", () => {
        const el = {
            nodeType: 1,
            nodeName: "SVG",
            attributes: [],
            childNodes: [
                {
                    nodeType: 1,
                    nodeName: "line",
                    attributes: [],
                    childNodes: []
                }
            ]
            // eslint-disable-next-line
        } as any;
        expect(isValid(el)).toBe(true);
    });

    it("is valid text node", () => {
        // eslint-disable-next-line
        const el = { nodeType: 3, nodeName: "#text" } as any;
        expect(isValid(el)).toBe(true);
    });
});

describe("validateContent", () => {
    it("removes title tags", () => {
        const input = "<svg><title>title</title><g></g></svg>";
        expect(validateContent(input)).toBe('<svg class="tux-icon__svg"><g></g></svg>');
    });
});
